module.exports = __webpack_public_path__ + "img/insurance-logo-5.97b534e8.png";